import loginActions from '../actionTypes/loginActions';
import employeesActions from '../actionTypes/employeesActions';
import storageHelpers from '../utils/storageHelpers';

const initialState = {
  isLoading: true,
  isLoggingIn: false,
  isLoggedIn: false,
  currentUser: null,
  mealTypes: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case loginActions.userLogin:
      return { ...state, isLoggingIn: true };
    case loginActions.setCurrentUser:
      return { ...state, isLoading: false, currentUser: action.payload };
    case loginActions.setMealTypes:
      return { ...state, isLoading: false, mealTypes: action.payload };
    case loginActions.userLoginSuccess:
      return {
        ...state,
        ...action.payload,
        isLoggingIn: false,
        currentUser: action.payload.data.attributes,
        mealTypes: action.payload.data.meal_types,
        isLoggedIn: true,
      };
    case loginActions.userLoginFailed:
      return {
        ...state,
        ...action.payload,
        isLoggingIn: false,
        isLoggedIn: false,
      };
    case loginActions.logoutUser:
      return { ...initialState, isLoading: false };
    case employeesActions.employeeProfileUpdateSuccess:
      storageHelpers.setItem('currentUser', action.payload.data.attributes);
      return {
        ...state,
        currentUser: action.payload.data.attributes,
        mealTypes: action.payload.data.meal_types,
      };
    default:
      return state;
  }
};
